import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from "@nosto/preact"
import { useEffect, useState } from "preact/hooks"
import RangeInput from "./elements/RangeInput"
import Icon from "./elements/Icon"

export default function RangeFacet({ facet, toggledFacet, setToggledFacet }) {
    const { min, max, range, updateRange } = useRangeSlider(facet.id)
    const isSelected = min !== range[0] || max !== range[1]
    const [active, setActive] = useState(isSelected)

    useEffect(()=>{
        if(toggledFacet === facet?.id){
            if(!active){
                // toggleActive();
                setActive(true);
            }
        } else {
            if(active){
                // toggleActive();
                setActive(false)
            }
        }
    },[toggledFacet, setToggledFacet])

    return (
        <li class={`ns-sidebar-dropdown ns-range-facet ${active ? "ns-active" : ""}`}>
            <span
            // ns-p-4
                class="ns-anchor ns-d-inline-flex ns-justify-content-between ns-relative ns-w-100 ns-border-box"
                tabIndex="0"
                onClick={() => {
                    setActive(!active)
                }}
            >
                {/* ns-font-4 */}
                <span class="ns-color-black">{facet.name}</span>
                {/* {isSelected && (
                    <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary">
                        {1}
                    </span>
                )} */}
                {/* className="ns-absolute" */}
                <Icon name="arrow" />
            </span>
            {/* ns-p-4 */}
            <div class="ns-sidebar-submenu ns-d-none" role="group" aria-labelledby={`${facet.id}-range-label`}>
            <div id={`${facet.id}-range-label`} class="sr-only">Price range slider for {facet.name}</div>
            <RangeSlider 
                id={facet.id} 
                aria-label={`${facet.name} range slider`}
                aria-describedby={`${facet.id}-range-description`}
            />
            <div id={`${facet.id}-range-description`} class="sr-only">
                Use arrow keys to adjust the range. Current range: {range[0]} to {range[1]}
            </div>
            {/* ns-font-4 */}
                <div class="ns-d-flex ns-justify-content-between">
                    <div class="ns-col-6 flex-shrink-1 ns-mr-2">
                        <label for={`ns-${facet.id}-min`} class="ns-form-label">
                            Minimum {facet.name}
                        </label>
                        <RangeInput
                            id={`ns-${facet.id}-min`}
                            min={min}
                            max={max}
                            range={range}
                            value={range[0]}
                            onChange={e => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([value, range[1]])
                            }}
                            className={'ns-range-from'}
                            aria-label={`Minimum ${facet.name}`}
                        />
                    </div>
                    <div class="ns-col-6 flex-shrink-1">
                        <label for={`ns-${facet.id}-max`} class="ns-form-label">
                            Maximum {facet.name}
                        </label>
                        <RangeInput
                            id={`ns-${facet.id}-max`}
                            min={min}
                            max={max}
                            range={range}
                            value={range[1]}
                            onChange={e => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([range[0], value])
                            }}
                            className={'ns-range-to'}
                            aria-label={`Maximum ${facet.name}`}
                        />
                    </div>
                </div>
               
            </div>
        </li>
    )
}


// version commented on October 2nd to adapt code for ADA compliance

// import { RangeSlider, useRangeSlider } from "@nosto/preact"
// import { useEffect, useState } from "preact/hooks"
// import RangeInput from "./elements/RangeInput"
// import Icon from "./elements/Icon"

// export default function RangeFacet({ facet, toggledFacet, setToggledFacet }) {
//     const { min, max, range, updateRange } = useRangeSlider(facet.id)
//     const isSelected = min !== range[0] || max !== range[1]
//     const [active, setActive] = useState(isSelected)

//     useEffect(()=>{
//         if(toggledFacet === facet?.id){
//             if(!active){
//                 // toggleActive();
//                 setActive(true);
//             }
//         } else {
//             if(active){
//                 // toggleActive();
//                 setActive(false)
//             }
//         }
//     },[toggledFacet, setToggledFacet])

//     return (
//         <li class={`ns-sidebar-dropdown ns-range-facet ${active ? "ns-active" : ""}`}>
//             <span
//             // ns-p-4
//                 class="ns-anchor ns-d-inline-flex ns-justify-content-between ns-relative ns-w-100 ns-border-box"
//                 tabIndex="0"
//                 onClick={() => {
//                     setActive(!active)
//                 }}
//             >
//                 {/* ns-font-4 */}
//                 <span class="ns-color-black">{facet.name}</span>
//                 {/* {isSelected && (
//                     <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary">
//                         {1}
//                     </span>
//                 )} */}
//                 {/* className="ns-absolute" */}
//                 <Icon name="arrow" />
//             </span>
//             {/* ns-p-4 */}
//             <div class="ns-sidebar-submenu ns-d-none">
//             <RangeSlider id={facet.id} />
//             {/* ns-font-4 */}
//                 <div class="ns-d-flex ns-justify-content-between">
//                     <div class="ns-col-6 flex-shrink-1 ns-mr-2">
//                         {/* <label for={`ns-${facet.id}-min`} class="ns-form-label">
//                             Min.
//                         </label> */}
//                         <RangeInput
//                             id={`ns-${facet.id}-min`}
//                             min={min}
//                             max={max}
//                             range={range}
//                             value={range[0]}
//                             onChange={e => {
//                                 const value = parseFloat(e.currentTarget.value) || undefined
//                                 updateRange([value, range[1]])
//                             }}
//                             className={'ns-range-from'}
//                         />
//                     </div>
//                     <div class="ns-col-6 flex-shrink-1">
//                         {/* <label for={`ns-${facet.id}-max`} class="ns-form-label">
//                             Max.
//                         </label> */}
//                         <RangeInput
//                             id={`ns-${facet.id}-max`}
//                             min={min}
//                             max={max}
//                             range={range}
//                             value={range[1]}
//                             onChange={e => {
//                                 const value = parseFloat(e.currentTarget.value) || undefined
//                                 updateRange([range[0], value])
//                             }}
//                             className={'ns-range-to'}
//                         />
//                     </div>
//                 </div>
               
//             </div>
//         </li>
//     )
// }
